import styled from 'styled-components';

export const HStack = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
  margin: auto;
`;
